import { IE_COUNTIES, UK_REGIONS } from "@/constants/data";

/**
 * Chip-style multi-select for extra counties/regions a worker will travel to.
 * Displays them grouped by country (Ireland first, then UK).
 * `primary` is excluded from the chip list (it's the home county).
 */
export default function CountiesPicker({ primary, value = [], onChange }) {
  const toggle = (c) => {
    if (value.includes(c)) {
      onChange(value.filter((x) => x !== c));
    } else {
      onChange([...value, c]);
    }
  };
  const ieOptions = IE_COUNTIES.filter((c) => c !== primary);
  const ukOptions = UK_REGIONS.filter((c) => c !== primary);
  const renderChip = (c) => {
    const active = value.includes(c);
    return (
      <button
        type="button"
        key={c}
        data-testid={`county-chip-${c.toLowerCase().replace(/\s+/g, "-")}`}
        onClick={() => toggle(c)}
        className={`text-[11px] uppercase tracking-widest px-3 py-1.5 border transition-colors ${
          active
            ? "bg-amber-500 text-neutral-950 border-amber-500 font-bold"
            : "bg-neutral-950 text-neutral-400 border-neutral-800 hover:border-amber-500 hover:text-amber-500"
        }`}
      >
        {c}
      </button>
    );
  };
  return (
    <div data-testid="counties-picker" className="space-y-3">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-1.5">🇮🇪 Ireland</div>
        <div className="flex flex-wrap gap-1.5">{ieOptions.map(renderChip)}</div>
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-1.5">🇬🇧 United Kingdom</div>
        <div className="flex flex-wrap gap-1.5">{ukOptions.map(renderChip)}</div>
      </div>
    </div>
  );
}
